<template>
    <div
        class="home-types relative-section camping-types"
        v-if="campingDetail && campingDetail.acf"
    >
        <img class="heber" src="../assets/images/hebergements.png" alt="" />
        <div class="container">
            <h2
                class="relative-section text-center section-title font-balo font-bold"
            >
                <span>{{ campingDetail.acf.camde_subtitle }}</span>
                <b>{{ campingDetail.acf.camde_title }}</b>
            </h2>
            <div
                class="the-tab"
                v-if="campingDetail.acf.camde_type_list.length > 0"
            >
                <div class="text-center tab-nav">
                    <ul class="list-inline font-bai font-bold">
                        <li
                            class="item-inline"
                            :class="{
                                active: currentTab === `campingType${index}`
                            }"
                            v-for="(item, index) in campingDetail.acf
                                .camde_type_list"
                            :key="index"
                        >
                            <a
                                href="#campingType1"
                                @click.prevent="
                                    onChangeTab(`campingType${index}`)
                                "
                                >{{ item.name }}</a
                            >
                        </li>
                    </ul>
                </div>
                <div
                    class="content-tab"
                    :id="`campingType${index}`"
                    :class="{ active: currentTab === `campingType${index}` }"
                    v-for="(camdeType, index) in campingDetail.acf
                        .camde_type_list"
                    :key="index"
                >
                    <div
                        class="type-list"
                        v-if="camdeType.list_content.length > 0"
                    >
                        <template
                            v-for="(item, index2) in camdeType.list_content"
                        >
                            <div
                                class="type-item"
                                v-if="(index2 + 1) % 2 !== 0"
                                :key="index2"
                            >
                                <div class="list-inline">
                                    <div class="item-inline item-large">
                                        <div class="image-fit">
                                            <img
                                                :src="item.image_1"
                                                :alt="item.title"
                                            />
                                        </div>
                                    </div>
                                    <div class="item-inline item-small">
                                        <div class="image-fit">
                                            <img
                                                :src="item.image_2"
                                                :alt="item.title"
                                            />
                                        </div>
                                    </div>
                                    <div class="item-inline">
                                        <div class="info">
                                            <h3 class="font-balo font-bold">
                                                <a href="" @click.prevent>{{
                                                    item.title
                                                }}</a>
                                            </h3>
                                            <div v-html="item.des" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="type-item type-item-other"
                                v-if="(index2 + 1) % 2 === 0"
                                :key="index2"
                            >
                                <div class="list-inline">
                                    <div class="item-inline">
                                        <div class="info">
                                            <h3 class="font-balo font-bold">
                                                <a href="" @click.prevent>{{
                                                    item.title
                                                }}</a>
                                            </h3>
                                            <div v-html="item.des" />
                                        </div>
                                    </div>
                                    <div class="item-inline item-small">
                                        <div class="image-fit">
                                            <img
                                                :src="item.image_1"
                                                :alt="item.title"
                                            />
                                        </div>
                                    </div>
                                    <div class="item-inline item-large">
                                        <div class="image-fit">
                                            <img
                                                :src="item.image_2"
                                                :alt="item.title"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
    name: "CampingTypes",
    data() {
        return {
            currentTab: "campingType0"
        };
    },
    methods: {
        onChangeTab(tab) {
            this.currentTab = tab;
        }
    },
    computed: {
        ...mapState({
            campingDetail: state => get(state, "campingClubs.detail", null)
        })
    }
};
</script>
